import React from 'react';
import { shape, string } from 'prop-types';
import classnames from 'classnames';
import { VisuallyHidden } from '@andes/common';
import colornames from '../../lib/colornames';
import IconFactory from '../icons/factory-builder';

const DEFAULT_COLOR = 'RED';

const ErrorMessage = ({ color = DEFAULT_COLOR, text, icon = null, namespace = '', className = '' }) => {
  const errorMessageRef = React.useRef(null);

  React.useEffect(() => {
    if (errorMessageRef.current) {
      errorMessageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, []);

  const isErrorBadge = icon?.id === 'error_badge' || icon?.id === 'ERROR_BADGE';
  const iconId = isErrorBadge ? 'message_alert' : icon?.id;

  return (
    <span
      ref={errorMessageRef}
      data-testid="error-message"
      aria-live="assertive"
      className={classnames(`${namespace}__alert`, colornames(color), className)}
    >
      <VisuallyHidden role="alert" aria-live="assertive">
        {text}
      </VisuallyHidden>
      {icon && IconFactory(iconId, colornames(icon.color))}
      <span className={`${namespace}__alert-text`}>{text}</span>
    </span>
  );
};

ErrorMessage.propTypes = {
  className: string,
  color: string,
  icon: shape({
    id: string,
    color: string,
  }),
  text: string.isRequired,
  namespace: string,
};

export default ErrorMessage;
